import {
  useState, useEffect,
  forwardRef, memo,
} from 'react';
import { useTranslation } from '@/helpers/translate';
import Icon from '@/core/icon';
import FiltersContent from './content';
import Emitter from '@/helpers/emitter';

const FiltersOnFilter = forwardRef(({ filters, onClose, keyFilter }, ref) => {
  const { t } = useTranslation();

  function cleanFilters() {
    (ref?.current?.getRefs() || []).forEach((filter) => {
      filter?.current?.clearValue(false);
    });
  }
  return (
    <>
      <div className="absolute top-0 left-0 z-50 w-screen bg-purple-6/60 h-dvh" />
      <div className="z-50 fixed top-0 bottom-0 h-dvh w-full overflow-hidden bg-white lg:w-[500px] lg:rounded-xl lg:h-[90vh] lg:absolute lg:left-1/2 lg:top-1/2 lg:transform lg:-translate-x-1/2 lg:-translate-y-1/2 shadow-button">
        <div className="fixed top-0 z-10 w-full h-16 px-6 py-5 bg-white border-b rounded-t-xl border-white-dark3">
          <h1 className="text-lg font-medium">{t('search:filter.more_filters')}</h1>
          <button
            className="absolute w-4 right-6 top-6"
            onClick={() => {
              Emitter.emit(`${keyFilter}runSearch`);
              onClose(false);
            }}
          >
            <Icon name="close" className="w-full h-4 mx-1 fill-current text-purple-5/50 lg:text-white-dark4 hover:text-black" />
          </button>
        </div>
        <div className="absolute w-full px-6 overflow-y-auto h-[calc(100%-8rem)] top-16 lg:px-10">
          <div className="flex flex-col py-8 gap-y-8 lg:gap-y-12">
            <FiltersContent {...{ filters, onFilter: true }} ref={ref} />
          </div>
        </div>
        <div className="fixed bottom-0 z-10 w-full px-6 py-5 bg-white border-t border-white-dark3">
          <div className="flex justify-between">
            <button className="text-base border-b rounded-none text-purple-5/50 border-purple-5/50 hover:text-purple hover:border-purple" onClick={() => cleanFilters()}>{t('search:clean')}</button>
            <button
              className="px-6 py-2 blue"
              onClick={() => {
                Emitter.emit(`${keyFilter}runSearch`);
                onClose(false);
              }}
            >
              {t('search:save')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
});

function FilterPlusCounting({ setIsOpenModal }) {
  const { t } = useTranslation();
  const [count, setCount] = useState(0);

  const keepCount = (output) => {
    setCount(output?.length || 0);
  };

  useEffect(() => {
    Emitter.on('filterpluslistenercounting', keepCount);
    return () => {
      Emitter.off('filterpluslistenercounting', keepCount);
    };
  }, []);

  return (
    <button
      className={`cursor-pointer z-30 size-11 text-sm md:size-fit lg:z-0 fixed lg:static top-3 right-3 items-center lg:ml-3 lg:mb-4 justify-center lg:py-[8px] px-[10px] py-3 rounded-full md:rounded-lg flex md:border-0 transition-colors duration-300 ${count ? 'text-white bg-purple' : 'bg-purple-6 hover:bg-purple/70 group text-purple-0'}`}
      onClick={() => { setIsOpenModal(true); }}
    >
      <Icon name="filters" className={`lg:mr-1 fill-current size-4 transition-colors duration-300  group-hover:text-white ${count ? 'text-white' : 'text-white lg:text-purple-4/70 group-hover:text-white'}`} />
      <span className="hidden lg:ml-2 lg:flex">{t('btn:filters')}</span>
      {!count || <div className="absolute flex items-center justify-center w-5 h-5 ml-2 bg-white border-2 rounded-full text-purple -top-1 -right-1 lg:static md:border-0"><span className="text-[10px] font-medium">{count}</span></div>}
    </button>
  );
}

const FilterPlus = forwardRef(({ filters, keyFilter }, ref) => {
  // console.log('search/filters/filterPlus - FILTER PLUS');

  const [isOpenModal, setIsOpenModal] = useState(false);

  function onCloseModal(value) {
    setIsOpenModal(value);
  }

  return (
    <>
      <FilterPlusCounting {...{ setIsOpenModal }} />
      <div style={isOpenModal ? {} : { display: 'none' }}>
        <FiltersOnFilter
          {...{
            keyFilter,
            filters,
            onClose: (value) => {
              onCloseModal(value);
            },
          }}
          ref={ref}
        />
      </div>
    </>
  );
});

export default memo(FilterPlus);
